export default {

    'experienced' : { type: 'experience' },
    'proven track record' : { type: 'experience' },
    'track record' : { type: 'experience' },
    'ideally' : { type: 'experience' },
    'experience( working )?(with|in|of|at)?' : { type: 'experience' },
    'experience' : { type: 'experience' },
    '([\\d+-]+\\s)+(or more|plus)?(\\s)*year(s)?' : { type: 'experience' },

    'touch base' : { type: 'bullshit' },
    'bandwidth' : { type: 'bullshit' },
    'going forward' : { type: 'bullshit' },
    'synergy' : { type: 'bullshit' },
    'synergize' : { type: 'bullshit' },
    'synergise' : { type: 'bullshit' },
    'paradigm shift' : { type: 'bullshit' },
    'outside the box' : { type: 'bullshit' },
    'blue sky thinking' : { type: 'bullshit' },
    'ducks in a row' : { type: 'bullshit' },
    'pushing the envelope' : { type: 'bullshit' },
    'joined up thinking' : { type: 'bullshit' },
    'low hanging fruit' : { type: 'bullshit' },
    'float(ing)? an idea' : { type: 'bullshit' },
    'unique selling point' : { type: 'bullshit' },
    'leverage' : { type: 'bullshit' },
    'state of the art' : { type: 'bullshit' },
    'ground breaking' : { type: 'bullshit' },
    'circle back' : { type: 'bullshit' },
    'reach out' : { type: 'bullshit' },
    'boil(ing)? the ocean' : { type: 'bullshit' },
    'at the end of the day' : { type: 'bullshit' },
    'mov(e|ing) the needle' : { type: 'bullshit' },
    'game chang(er|ing)' : { type: 'bullshit' },
    'right sizing' : { type: 'bullshit' },
    'value add(ed|ing)?' : { type: 'bullshit' },
    'mission critical' : { type: 'bullshit' },

    '(selective|top|respected)? (university|uni|school|college)' : { type: 'education' },
    '(first|1st|second|2nd) class (degree|honours|honors)' : { type: 'education' },
    '(2-1|2:1) (or|and) (above|up)' : { type: 'education' },
    'degree( level)?' : { type: 'education' },
    'masters|master|bachelors|diploma|bachelor|honors|honours|PHD|MBA' : { type: 'education' },

    she: {
        type: 'feminine',
        synonyms: ['they'],
    },
    hers: {
        type: 'feminine',
        synonyms: ['theirs'],
    },
    agreement: {
        type: 'feminine',
        synonyms: ['arrangement', 'settlement', 'concord'],
    },
    agreements: {
        type: 'feminine',
        synonyms: ['arrangements', 'settlements', 'concords'],
    },
    agreed: {
        type: 'feminine',
        synonyms: ['concluded', 'resolved', 'established'],
    },
    agree: {
        type: 'feminine',
        synonyms: ['conclude', 'resolve', 'concur'],
    },
    agrees: {
        type: 'feminine',
        synonyms: ['concludes', 'resolves', 'concurs'],
    },
    agreeable: {
        type: 'feminine',
        synonyms: ['accordant', 'consistent', 'concordant'],
    },
    affectionate: {
        type: 'feminine',
        synonyms: ['fond', 'caring', 'comforting'],
    },
    child: {
        type: 'feminine',
        synonyms: ['juvenile', 'infant'],
    },
    children: {
        type: 'feminine',
        synonyms: ['juveniles', 'infants'],
    },
    cheery: {
        type: 'feminine',
        synonyms: ['buoyant', 'upbeat', 'optimistic'],
    },
    cheer: {
        type: 'feminine',
        synonyms: ['applaud', 'commend', 'approve'],
    },
    cheers: {
        type: 'feminine',
        synonyms: ['applauds', 'commends', 'approves'],
    },
    cheered: {
        type: 'feminine',
        synonyms: ['applauded', 'commended', 'approved'],
    },
    cheering: {
        type: 'feminine',
        synonyms: ['applauding', 'commending', 'approving of'],
    },
    cheerful: {
        type: 'feminine',
        synonyms: ['buoyant', 'upbeat', 'optimistic'],
    },
    collaborate: {
        type: 'feminine',
        synonyms: ['work with', 'partner', 'team up'],
    },
    collaborates: {
        type: 'feminine',
        synonyms: ['works with', 'partners', 'teams up'],
    },
    collaborative: {
        type: 'feminine',
        synonyms: ['concerted', 'joint', 'combined'],
    },
    collaboration: {
        type: 'feminine',
        synonyms: ['partnership', 'alliance', 'association'],
    },
    committed: {
        type: 'feminine',
        synonyms: ['dedicated', 'unswerving', 'staunch'],
    },
    commit: {
        type: 'feminine',
        synonyms: ['dedicate', 'give', 'employ'],
    },
    commits: {
        type: 'feminine',
        synonyms: ['dedicates', 'gives', 'employs'],
    },
    commitment: {
        type: 'feminine',
        synonyms: ['dedication', 'sincerity', 'investment'],
    },
    committal: {
        type: 'feminine',
        synonyms: ['interment', 'burial', 'entombment'],
    },
    communal: {
        type: 'feminine',
        synonyms: ['group', 'team', 'peers'],
    },
    commune: {
        type: 'feminine',
        synonyms: ['collective', 'group', 'team'],
    },
    communicate: {
        type: 'feminine',
        synonyms: ['convey', 'speak', 'impart'],
    },
    communicated: {
        type: 'feminine',
        synonyms: ['conveyed', 'spoke', 'imparted'],
    },
    communicates: {
        type: 'feminine',
        synonyms: ['conveys', 'speaks', 'imparts'],
    },
    communicator: {
        type: 'feminine',
        synonyms: ['advisor', 'speaker', 'orator'],
    },
    communicators: {
        type: 'feminine',
        synonyms: ['advisors', 'speakers', 'orators'],
    },
    communicating: {
        type: 'feminine',
        synonyms: ['conveying', 'speaking', 'imparting'],
    },
    compassion: {
        type: 'feminine',
        synonyms: ['concern', 'benevolence', 'mindful'],
    },
    compassionate: {
        type: 'feminine',
        synonyms: ['concerned', 'benevolent', 'mindful'],
    },
    connect: {
        type: 'feminine',
        synonyms: ['join', 'link', 'unite'],
    },
    connected: {
        type: 'feminine',
        synonyms: ['joined', 'linked', 'united'],
    },
    connects: {
        type: 'feminine',
        synonyms: ['joins', 'links', 'unites'],
    },
    connecting: {
        type: 'feminine',
        synonyms: ['joining', 'linking', 'uniting'],
    },
    connector: {
        type: 'feminine',
        synonyms: ['linker', 'combiner', 'joiner'],
    },
    connectors: {
        type: 'feminine',
        synonyms: ['joiners', 'advisors'],
    },
    considerate: {
        type: 'feminine',
        synonyms: ['attentive', 'respectful', 'mindful'],
    },
    cooperate: {
        type: 'feminine',
        synonyms: ['liaise', 'partner', 'pool resources'],
    },
    cooperates: {
        type: 'feminine',
        synonyms: ['liaises', 'partners', 'pools resources'],
    },
    cooperating: {
        type: 'feminine',
        synonyms: ['liaising', 'partnering', 'pooling resources'],
    },
    cooperated: {
        type: 'feminine',
        synonyms: ['liaised', 'partnered', 'pooled resources'],
    },
    'co-operate': {
        type: 'feminine',
        synonyms: ['liaise', 'partner', 'pool resources'],
    },
    'co-operates': {
        type: 'feminine',
        synonyms: ['liaises', 'partners', 'pools resources'],
    },
    'co-operating': {
        type: 'feminine',
        synonyms: ['liaising', 'partnering', 'pooling resources'],
    },
    'co-operated': {
        type: 'feminine',
        synonyms: ['liaised', 'partnered', 'pooled resources'],
    },
    cooperative: {
        type: 'feminine',
        synonyms: ['helpful', 'compliant', 'two-way'],
    },
    'co-operative': {
        type: 'feminine',
        synonyms: ['helpful', 'compliant', 'two-way'],
    },
    cooperation: {
        type: 'feminine',
        synonyms: ['assistance', 'teamwork', 'help'],
    },
    'co-operation': {
        type: 'feminine',
        synonyms: ['assistance', 'teamwork', 'help'],
    },
    depend: {
        type: 'feminine',
        synonyms: ['rely', 'hinge on', 'rest on'],
    },
    depends: {
        type: 'feminine',
        synonyms: ['relies', 'hinges on', 'rests on'],
    },
    depended: {
        type: 'feminine',
        synonyms: ['relied', 'hinged on', 'rested on'],
    },
    depending: {
        type: 'feminine',
        synonyms: ['relying', 'hinging on', 'resting on'],
    },
    dependable: {
        type: 'feminine',
        synonyms: ['responsible', 'reliable', 'steadfast'],
    },
    dependably: {
        type: 'feminine',
        synonyms: ['reliably', 'consistently', 'regularly'],
    },
    emotional: {
        type: 'feminine',
        synonyms: ['open', 'responsive', 'passionate'],
    },
    emotionally: {
        type: 'feminine',
        synonyms: ['openly', 'ardently', 'passionately'],
    },
    emotion: {
        type: 'feminine',
        synonyms: ['sentiment', 'passion', 'sensation'],
    },
    emotions: {
        type: 'feminine',
        synonyms: ['sentiments', 'passions', 'sensations'],
    },
    empathy: {
        type: 'feminine',
        synonyms: ['affinity', 'appreciation', 'rapport'],
    },
    empathetic: {
        type: 'feminine',
        synonyms: ['concerned', 'benevolent', 'mindful'],
    },
    empathise: {
        type: 'feminine',
        synonyms: ['relate to', 'identify with'],
    },
    empathises: {
        type: 'feminine',
        synonyms: ['relates to', 'identifies with'],
    },
    empathised: {
        type: 'feminine',
        synonyms: ['related to', 'identified with'],
    },
    empathize: {
        type: 'feminine',
        synonyms: ['relate to', 'identify with'],
    },
    empathizes: {
        type: 'feminine',
        synonyms: ['relates to', 'identifies with'],
    },
    empathized: {
        type: 'feminine',
        synonyms: ['related to', 'identified with'],
    },
    feel: {
        type: 'feminine',
        synonyms: ['touch', 'sense', 'impress'],
    },
    feeling: {
        type: 'feminine',
        synonyms: ['sentiment', 'passion', 'sensation'],
    },
    feelings: {
        type: 'feminine',
        synonyms: ['frame of mind', 'outlook', 'position'],
    },
    feels: {
        type: 'feminine',
        synonyms: ['touches', 'senses', 'impresses'],
    },
    felt: {
        type: 'feminine',
        synonyms: ['touched', 'sensed', 'impressed'],
    },
    flatter: {
        type: 'feminine',
        synonyms: ['praise', 'grow', 'encourage'],
    },
    flattering: {
        type: 'feminine',
        synonyms: ['praising', 'growing', 'encouraging'],
    },
    flattered: {
        type: 'feminine',
        synonyms: ['praised', 'grown', 'encouraged'],
    },
    flatters: {
        type: 'feminine',
        synonyms: ['praises', 'grows', 'encourages'],
    },
    flatterable: {
        type: 'feminine',
        synonyms: ['open to compliments', 'open to feedback'],
    },
    flattery: {
        type: 'feminine',
        synonyms: ['adulation', 'praise'],
    },
    gentle: {
        type: 'feminine',
        synonyms: ['moderate', 'genial', 'calm'],
    },
    gentler: {
        type: 'feminine',
        synonyms: ['calmer', 'more moderate', 'more genial'],
    },
    honest: {
        type: 'feminine',
        synonyms: ['authentic', 'direct', 'frank'],
    },
    interpersonal: {
        type: 'feminine',
        synonyms: ['interactive', 'social', 'stakeholder management'],
    },
    interdependent: {
        type: 'feminine',
        synonyms: ['reliant', 'interlinking', 'codependent'],
    },
    interdependently: {
        type: 'feminine',
        synonyms: ['cohesively', 'closely', 'complementarily'],
    },
    interdependence: {
        type: 'feminine',
        synonyms: ['reliance', 'codependent'],
    },
    'inter-personal': {
        type: 'feminine',
        synonyms: ['interactive', 'social', 'stakeholder management'],
    },
    'inter-dependent': {
        type: 'feminine',
        synonyms: ['reliant', 'interlinking', 'codependent'],
    },
    'inter-dependently': {
        type: 'feminine',
        synonyms: ['cohesively', 'closely', 'complementarily'],
    },
    'inter-dependence': {
        type: 'feminine',
        synonyms: ['reliance', 'codependent'],
    },
    kind: {
        type: 'feminine',
        synonyms: ['generous', 'thoughtful', 'benevolent'],
    },
    kinder: {
        type: 'feminine',
        synonyms: ['more generous', 'more thoughtful'],
    },
    kindness: {
        type: 'feminine',
        synonyms: ['generosity', 'thoughtfulness', 'benevolence'],
    },
    kinship: {
        type: 'feminine',
        synonyms: ['affinity', 'association', 'affiliation'],
    },
    loyal: {
        type: 'feminine',
        synonyms: ['reliable', 'devoted', 'dedicated'],
    },
    loyalty: {
        type: 'feminine',
        synonyms: ['reliability', 'steadfastness'],
    },
    modesty: {
        type: 'feminine',
        synonyms: ['reserve', 'humility', 'discretion'],
    },
    nag: {
        type: 'feminine',
        synonyms: ['ask', 'enquire', 'put pressure on'],
    },
    nurture: {
        type: 'feminine',
        synonyms: ['cherish', 'foster', 'develop'],
    },
    nurtures: {
        type: 'feminine',
        synonyms: ['cherishes', 'fosters', 'develops'],
    },
    nurturing: {
        type: 'feminine',
        synonyms: ['cherishing', 'fostering', 'developing'],
    },
    nurtured: {
        type: 'feminine',
        synonyms: ['cherished', 'fostered', 'developed'],
    },
    pleasant: {
        type: 'feminine',
        synonyms: ['genial', 'affable', 'friendly'],
    },
    pleasantly: {
        type: 'feminine',
        synonyms: ['pleasingly', 'enjoyaby', 'nicely'],
    },
    polite: {
        type: 'feminine',
        synonyms: ['good-mannered', 'civil', 'courteous'],
    },
    quiet: {
        type: 'feminine',
        synonyms: ['inaudible', 'low', 'noiseless'],
    },
    quieter: {
        type: 'feminine',
        synonyms: ['lower', 'softer', 'serener'],
    },
    quietly: {
        type: 'feminine',
        synonyms: ['inaudibly', 'noiselessly'],
    },
    response: {
        type: 'feminine',
        synonyms: ['answer', 'reply', 'return'],
    },
    responsive: {
        type: 'feminine',
        synonyms: ['open', 'approachable', 'alert'],
    },
    responsiveness: {
        type: 'feminine',
        synonyms: ['openness', 'approachability', 'alertness'],
    },
    respond: {
        type: 'feminine',
        synonyms: ['answer', 'reply', 'rejoin'],
    },
    responds: {
        type: 'feminine',
        synonyms: ['answers', 'replies', 'rejoins'],
    },
    responding: {
        type: 'feminine',
        synonyms: ['answering', 'replying', 'rejoining'],
    },
    responses: {
        type: 'feminine',
        synonyms: ['answers', 'replies', 'reactions'],
    },
    responsible: {
        type: 'feminine',
        synonyms: ['accountable', 'dependable', 'reliable'],
    },
    responsibleness: {
        type: 'feminine',
        synonyms: ['accountability', 'dependability', 'reliability'],
    },
    responsibility: {
        type: 'feminine',
        synonyms: ['duty', 'remit', 'brief'],
    },
    responsibilities: {
        type: 'feminine',
        synonyms: ['remit', 'tasks', 'assignments'],
    },
    sensitive: {
        type: 'feminine',
        synonyms: ['thoughtful', 'perceptive', 'mindful'],
    },
    sensitivity: {
        type: 'feminine',
        synonyms: ['thoughtfulness', 'perceptiveness', 'mindfulness'],
    },
    submissive: {
        type: 'feminine',
        synonyms: ['compliant', 'accommodating', 'passive'],
    },
    submissiveness: {
        type: 'feminine',
        synonyms: ['compliance', 'passivity'],
    },
    support: {
        type: 'feminine',
        synonyms: ['sponsor', 'promote', 'boost'],
    },
    supports: {
        type: 'feminine',
        synonyms: ['sponsors', 'promotes', 'boosts'],
    },
    supported: {
        type: 'feminine',
        synonyms: ['sponsored', 'promoted', 'boosted'],
    },
    supporting: {
        type: 'feminine',
        synonyms: ['sponsoring', 'promoting', 'boosting'],
    },
    supportive: {
        type: 'feminine',
        synonyms: ['encouraging', 'accommodating', 'helpful'],
    },
    sympathy: {
        type: 'feminine',
        synonyms: ['concern', 'benevolence', 'appreciate'],
    },
    sympathetic: {
        type: 'feminine',
        synonyms: ['benevolent', 'concerned'],
    },
    tender: {
        type: 'feminine',
        synonyms: ['fond', 'caring', 'comforting'],
    },
    tenderness: {
        type: 'feminine',
        synonyms: ['fondness', 'caring', 'comforting'],
    },
    tenderly: {
        type: 'feminine',
        synonyms: ['fondly', 'caringly'],
    },
    together: {
        type: 'feminine',
        synonyms: ['mutually', 'jointly', 'collectively'],
    },
    togetherness: {
        type: 'feminine',
        synonyms: ['friendship', 'attachment', 'closeness'],
    },
    trust: {
        type: 'feminine',
        synonyms: ['reliance', 'believe'],
    },
    trusts: {
        type: 'feminine',
        synonyms: ['relies', 'hinges on', 'rests on'],
    },
    trusted: {
        type: 'feminine',
        synonyms: ['rely on', 'hinged on', 'count on'],
    },
    trusting: {
        type: 'feminine',
        synonyms: ['believing', 'relying on', 'hinging on'],
    },
    trusty: {
        type: 'feminine',
        synonyms: ['reliable', 'constant', 'dependable'],
    },
    trustworthy: {
        type: 'feminine',
        synonyms: ['reliable', 'constant', 'dependable'],
    },
    trustworthyness: {
        type: 'feminine',
        synonyms: ['reliability', 'dependability'],
    },
    understand: {
        type: 'feminine',
        synonyms: ['appreciate', 'comprehend', 'see'],
    },
    understanding: {
        type: 'feminine',
        synonyms: ['appreciation', 'comprehension', 'realisation'],
    },
    understands: {
        type: 'feminine',
        synonyms: ['appreciates', 'comprehends', 'sees'],
    },
    understandable: {
        type: 'feminine',
        synonyms: ['comprehensible', 'clear', 'plausible'],
    },
    understood: {
        type: 'feminine',
        synonyms: ['appreciated', 'comprehended', 'realised'],
    },
    warm: {
        type: 'feminine',
        synonyms: ['fond', 'caring', 'comforting'],
    },
    warms: {
        type: 'feminine',
        synonyms: ['heats', 'melts'],
    },
    warmer: {
        type: 'feminine',
        synonyms: ['fonder', 'sincerer', 'deeper'],
    },
    warming: {
        type: 'feminine',
        synonyms: ['heating', 'melting'],
    },
    whine: {
        type: 'feminine',
        synonyms: ['complain', 'take issue with', 'bring up'],
    },
    whining: {
        type: 'feminine',
        synonyms: ['complaining', 'taking issue with', 'bringing up'],
    },
    whined: {
        type: 'feminine',
        synonyms: ['complained', 'took issue with', 'brought up'],
    },
    whinge: {
        type: 'feminine',
        synonyms: ['complain', 'take issue with', 'bring up'],
    },
    whinging: {
        type: 'feminine',
        synonyms: ['complaining', 'taking issue with', 'bringing up'],
    },
    whinged: {
        type: 'feminine',
        synonyms: ['complained', 'took issue with', 'brought up'],
    },
    enthusiasm: {
        type: 'feminine',
        synonyms: ['interest', 'passion', 'excitement'],
    },
    enthusiastic: {
        type: 'feminine',
        synonyms: ['interested', 'passionate', 'excited'],
    },
    inclusive: {
        type: 'feminine',
        synonyms: ['all-encompassing', 'wide-ranging', 'complete'],
    },
    inclusiveness: {
        type: 'feminine',
        synonyms: ['completeness', 'comprehensiveness'],
    },
    yield: {
        type: 'feminine',
        synonyms: ['give', 'grant', 'produce'],
    },
    yields: {
        type: 'feminine',
        synonyms: ['gives', 'grants', 'produces'],
    },
    yielding: {
        type: 'feminine',
        synonyms: ['giving', 'granting', 'producing'],
    },
    yielded: {
        type: 'feminine',
        synonyms: ['gave', 'granted', 'produced'],
    },
    share: {
        type: 'feminine',
        synonyms: ['portion', 'segment', 'allocate'],
    },
    shares: {
        type: 'feminine',
        synonyms: ['portions', 'segments', 'allocates'],
    },
    shared: {
        type: 'feminine',
        synonyms: ['portioned', 'segmented', 'allocated'],
    },
    sharing: {
        type: 'feminine',
        synonyms: ['imparting', 'disclosing', 'revealing'],
    },


    he : {
        type: 'masculine',
        synonyms: ['they'],
    },
    his : {
        type: 'masculine',
        synonyms: ['theirs'],
    },
    active : {
        type: 'masculine',
        synonyms: ['dynamic', 'energetic', 'lively'],
    },
    activeness: {
        type: 'masculine',
        synonyms: ['liveliness', 'energy', 'animation'],
    },
    adventurous : {
        type: 'masculine',
        synonyms: ['exciting', 'exploratory', 'bold'],
    },
    adventurousness: {
        type: 'masculine',
        synonyms: ['boldness', 'daring'],
    },
    aggressive: {
        type: 'masculine',
        synonyms: ['insistent', 'unbending', 'uncompromising'],
    },
    aggressiveness: {
        type: 'masculine',
        synonyms: ['insistence', 'uncompromising'],
    },
    aggression: {
        type: 'masculine',
        synonyms: ['antagonism', 'offense'],
    },
    aggressor: {
        type: 'masculine',
        synonyms: ['antagonist', 'assailant'],
    },
    aggressors: {
        type: 'masculine',
        synonyms: ['antagonists', 'assailants'],
    },
    ambition: {
        type: 'masculine',
        synonyms: ['spirit', 'motivation'],
    },
    ambitious: {
        type: 'masculine',
        synonyms: ['striving', 'motivated', 'aspiring'],
    },
    ambitiousness: {
        type: 'masculine',
        synonyms: ['aspiration', 'desire', 'motivation'],
    },
    analyse: {
        type: 'masculine',
        synonyms: ['study', 'investigate', 'evaluate'],
    },
    analysed: {
        type: 'masculine',
        synonyms: ['studied', 'investigated', 'evaluated'],
    },
    analyses: {
        type: 'masculine',
        synonyms: ['studies', 'investigates', 'evaluates'],
    },
    analysing: {
        type: 'masculine',
        synonyms: ['studying', 'investigating', 'evaluating'],
    },
    analyze: {
        type: 'masculine',
        synonyms: ['study', 'investigate', 'evaluate'],
    },
    analyzed: {
        type: 'masculine',
        synonyms: ['studied', 'investigated', 'evaluated'],
    },
    analyzes: {
        type: 'masculine',
        synonyms: ['studies', 'investigates', 'evaluates'],
    },
    analyzing: {
        type: 'masculine',
        synonyms: ['studying', 'investigating', 'evaluating'],
    },
    analysis: {
        type: 'masculine',
        synonyms: ['exploration', 'enquiry', 'study', 'scrutiny'],
    },
    analyst: {
        type: 'masculine',
        synonyms: ['specialist', 'expert'],
    },
    analysts: {
        type: 'masculine',
        synonyms: ['specialists', 'experts'],
    },
    analytic: {
        type: 'masculine',
        synonyms: ['logical', 'diagnostic', 'systematic'],
    },
    analytics: {
        type: 'masculine',
        synonyms: ['diagnostics'],
    },
    analytical: {
        type: 'masculine',
        synonyms: ['logical', 'diagnostic', 'systematic'],
    },
    analytically: {
        type: 'masculine',
        synonyms: ['logically', 'systematically', 'rationally'],
    },
    assert : {
        type: 'masculine',
        synonyms: ['state', 'emphasise', 'maintain'],
    },
    asserted: {
        type: 'masculine',
        synonyms: ['stated', 'emphasised', 'maintained'],
    },
    asserts: {
        type: 'masculine',
        synonyms: ['states', 'emphasises', 'maintains'],
    },
    asserting: {
        type: 'masculine',
        synonyms: ['stating', 'emphasising', 'maintaining'],
    },
    assertive: {
        type: 'masculine',
        synonyms: ['forward', 'emphatic', 'insistent'],
    },
    assertiveness: {
        type: 'masculine',
        synonyms: ['insistence', 'confidence', 'boldness'],
    },
    athletic: {
        type: 'masculine',
        synonyms: ['energetic', 'agile', 'healthy'],
    },
    athlete: {
        type: 'masculine',
        synonyms: ['contestant', 'participant'],
    },
    autonomous: {
        type: 'masculine',
        synonyms: ['self-directed', 'self-starter', 'resourceful'],
    },
    autonomously: {
        type: 'masculine',
        synonyms: ['freely', 'alone'],
    },
    autonomy: {
        type: 'masculine',
        synonyms: ['self-guiding', 'self-directed'],
    },
    battle : {
        type: 'masculine',
        synonyms: ['engage', 'strive', 'dispute'],
    },
    battles: {
        type: 'masculine',
        synonyms: ['engages', 'strives', 'disputes'],
    },
    battled: {
        type: 'masculine',
        synonyms: ['engaged', 'strove', 'disputed'],
    },
    battling: {
        type: 'masculine',
        synonyms: ['engaging', 'striving', 'disputing'],
    },
    boast : {
        type: 'masculine',
        synonyms: ['state', 'emphasise', 'display'],
    },
    boasts: {
        type: 'masculine',
        synonyms: ['states', 'emphasises', 'displays'],
    },
    boasted: {
        type: 'masculine',
        synonyms: ['stated', 'emphasised', 'displayed'],
    },
    boasting: {
        type: 'masculine',
        synonyms: ['stating', 'emphasising', 'displaying'],
    },
    challenged: {
        type: 'masculine',
        synonyms: ['tested', 'questioned', 'opposed'],
    },
    challenge: {
        type: 'masculine',
        synonyms: ['test', 'trial', 'opportunity'],
    },
    challenges: {
        type: 'masculine',
        synonyms: ['tests', 'trials', 'opportunities'],
    },
    challenging: {
        type: 'masculine',
        synonyms: ['testing', 'taxing', 'stimulating'],
    },
    champion : {
        type: 'masculine',
        synonyms: ['back', 'advocate'],
    },
    champions: {
        type: 'masculine',
        synonyms: ['backs', 'advocates'],
    },
    championing: {
        type: 'masculine',
        synonyms: ['backing', 'advocating'],
    },
    championed: {
        type: 'masculine',
        synonyms: ['backed', 'advocated'],
    },
    compete: {
        type: 'masculine',
        synonyms: ['contend', 'strive', 'participate'],
    },
    competes: {
        type: 'masculine',
        synonyms: ['contends', 'strives', 'participates'],
    },
    competed: {
        type: 'masculine',
        synonyms: ['contended', 'strove', 'participated'],
    },
    competing: {
        type: 'masculine',
        synonyms: ['contending', 'striving', 'participating'],
    },
    competent: {
        type: 'masculine',
        synonyms: ['able', 'proficient', 'adept'],
    },
    competence: {
        type: 'masculine',
        synonyms: ['ability', 'aptitude', 'proficiency'],
    },
    competitive: {
        type: 'masculine',
        synonyms: ['spirited', 'motivated'],
    },
    competitiveness: {
        type: 'masculine',
        synonyms: ['effectiveness', 'spirit'],
    },
    competitively: {
        type: 'masculine',
        synonyms: ['spiritedly', 'effectively'],
    },
    confident : {
        type: 'masculine',
        synonyms: ['poised', 'assured', 'self-assured'],
    },
    confidence: {
        type: 'masculine',
        synonyms: ['poise', 'assurance', 'self-assurance'],
    },
    courageous: {
        type: 'masculine',
        synonyms: ['bold', 'intrepid', 'spirited'],
    },
    courageousness: {
        type: 'masculine',
        synonyms: ['daring', 'bravery'],
    },
    courage: {
        type: 'masculine',
        synonyms: ['resolution', 'daring', 'audacity'],
    },
    decide: {
        type: 'masculine',
        synonyms: ['select', 'resolve', 'elect'],
    },
    decides: {
        type: 'masculine',
        synonyms: ['selects', 'resolves', 'elects'],
    },
    decided: {
        type: 'masculine',
        synonyms: ['selected', 'resolved', 'elected'],
    },
    deciding: {
        type: 'masculine',
        synonyms: ['selecting', 'resolving', 'electing'],
    },
    decision : {
        type: 'masculine',
        synonyms: ['conclusion', 'result', 'finding'],
    },
    decisive : {
        type: 'masculine',
        synonyms: ['resolute', 'focused'],
    },
    decisiveness: {
        type: 'masculine',
        synonyms: ['resoluteness', 'resolve', 'drive'],
    },
    defend : {
        type: 'masculine',
        synonyms: ['endorse', 'stand for', 'look after'],
    },
    defends: {
        type: 'masculine',
        synonyms: ['endorses', 'stands for', 'looks after'],
    },
    defending: {
        type: 'masculine',
        synonyms: ['endorsing', 'standing for', 'looking after'],
    },
    defended: {
        type: 'masculine',
        synonyms: ['endorsed', 'stood for', 'looked after'],
    },
    determine: {
        type: 'masculine',
        synonyms: ['conclude', 'establish', 'finalise'],
    },
    determines: {
        type: 'masculine',
        synonyms: ['concludes', 'establishes', 'finalises'],
    },
    determined: {
        type: 'masculine',
        synonyms: ['concluded', 'established', 'finalised'],
    },
    determining: {
        type: 'masculine',
        synonyms: ['concluding', 'establishing', 'finalising'],
    },
    determination: {
        type: 'masculine',
        synonyms: ['resolve', 'purpose', 'fortitude'],
    },
    dominate: {
        type: 'masculine',
        synonyms: ['govern', 'direct', 'take over'],
    },
    dominates: {
        type: 'masculine',
        synonyms: ['governs', 'directs', 'takes over'],
    },
    dominated: {
        type: 'masculine',
        synonyms: ['governed', 'directed', 'took over'],
    },
    dominating: {
        type: 'masculine',
        synonyms: ['governing', 'directing', 'taking over'],
    },
    dominant : {
        type: 'masculine',
        synonyms: ['central', 'main', 'major'],
    },
    domination: {
        type: 'masculine',
        synonyms: ['control', 'rule'],
    },
    driven : {
        type: 'masculine',
        synonyms: ['motivated', 'compelled', 'focused'],
    },
    fearless : {
        type: 'masculine',
        synonyms: ['bold', 'intrepid', 'daring'],
    },
    fearlessness: {
        type: 'masculine',
        synonyms: ['boldness', 'audacity', 'daring'],
    },
    fight : {
        type: 'masculine',
        synonyms: ['oppose', 'contest', 'argue'],
    },
    fights: {
        type: 'masculine',
        synonyms: ['opposes', 'contests', 'argues'],
    },
    fighting: {
        type: 'masculine',
        synonyms: ['opposing', 'contesting', 'arguing'],
    },
    fought: {
        type: 'masculine',
        synonyms: ['opposed', 'contested', 'argued'],
    },
    force : {
        type: 'masculine',
        synonyms: ['oblige', 'make', 'press'],
    },
    forces: {
        type: 'masculine',
        synonyms: ['obliges', 'makes', 'presses'],
    },
    forcing: {
        type: 'masculine',
        synonyms: ['obliging', 'making', 'pressing'],
    },
    forced: {
        type: 'masculine',
        synonyms: ['obliged', 'made', 'pressed'],
    },
    forceful: {
        type: 'masculine',
        synonyms: ['dynamic', 'vigorous', 'influential'],
    },
    forcefulness: {
        type: 'masculine',
        synonyms: ['persuasiveness', 'potency'],
    },
    forcefully: {
        type: 'masculine',
        synonyms: ['dynamically', 'vigorously'],
    },
    greedy : {
        type: 'masculine',
        synonyms: ['eager', 'keen', 'acquisitive'],
    },
    'head-strong' : {
        type: 'masculine',
        synonyms: ['focused', 'motivated', 'compelled'],
    },
    headstrong : {
        type: 'masculine',
        synonyms: ['focused', 'motivated', 'compelled'],
    },
    hierarchy: {
        type: 'masculine',
        synonyms: ['structure', 'organisation', 'team'],
    },
    hierarchical: {
        type: 'masculine',
        synonyms: ['structured', 'organised', 'ordered'],
    },
    hostile: {
        type: 'masculine',
        synonyms: ['unsympathetic', 'adverse', 'unfavourable'],
    },
    hostility: {
        type: 'masculine',
        synonyms: ['opposition', 'adversity'],
    },
    impulsive : {
        type: 'masculine',
        synonyms: ['spontaneous', 'instinctive '],
    },
    impulsiveness: {
        type: 'masculine',
        synonyms: ['spontaneity', 'hastiness'],
    },
    independent: {
        type: 'masculine',
        synonyms: ['self-directed', 'self-starter'],
    },
    independently: {
        type: 'masculine',
        synonyms: ['freely', 'objectively'],
    },
    independence: {
        type: 'masculine',
        synonyms: ['self-directing', 'self-starting'],
    },
    individual : {
        type: 'masculine',
        synonyms: ['person', 'peer', 'colleague'],
    },
    individuals: {
        type: 'masculine',
        synonyms: ['people', 'peers', 'colleagues'],
    },
    intellect : {
        type: 'masculine',
        synonyms: ['intelligence', 'thinker', 'thoughtful'],
    },
    intellectual: {
        type: 'masculine',
        synonyms: ['thinker', 'academic', 'scholar'],
    },
    intellectuals: {
        type: 'masculine',
        synonyms: ['thinkers', 'academics', 'scholars'],
    },
    lead : {
        type: 'masculine',
        synonyms: ['guide', 'direct', 'steer'],
    },
    leader: {
        type: 'masculine',
        synonyms: ['head', 'principal', 'director'],
    },
    leaders: {
        type: 'masculine',
        synonyms: ['principals', 'directors'],
    },
    leading: {
        type: 'masculine',
        synonyms: ['guiding', 'directing', 'steering'],
    },
    led: {
        type: 'masculine',
        synonyms: ['guided', 'directed', 'steered'],
    },
    leads: {
        type: 'masculine',
        synonyms: ['guides', 'directs', 'steers'],
    },
    leadership: {
        type: 'masculine',
        synonyms: ['management', 'influence', 'direction'],
    },
    logic : {
        type: 'masculine',
        synonyms: ['reason', 'sense'],
    },
    objective : {
        type: 'masculine',
        synonyms: ['purpose', 'goal', 'intention'],
    },
    objectiveness: {
        type: 'masculine',
        synonyms: ['impartiality', 'fairness', 'evenhandedness'],
    },
    opinion : {
        type: 'masculine',
        synonyms: ['judgement', 'estimation', 'belief'],
    },
    outspoken : {
        type: 'masculine',
        synonyms: ['candid', 'frank', 'open'],
    },
    persist : {
        type: 'masculine',
        synonyms: ['continue', 'keep on', 'endure'],
    },
    persists: {
        type: 'masculine',
        synonyms: ['continues', 'keeps on', 'endures'],
    },
    persisted: {
        type: 'masculine',
        synonyms: ['continued', 'kept on', 'endured'],
    },
    persisting: {
        type: 'masculine',
        synonyms: ['continuing', 'keeping on', 'enduring'],
    },
    persistent: {
        type: 'masculine',
        synonyms: ['motivated', 'compelled'],
    },
    persistence: {
        type: 'masculine',
        synonyms: ['tenacity', 'resolve'],
    },
    principle : {
        type: 'masculine',
        synonyms: ['value', 'standard', 'belief'],
    },
    principles: {
        type: 'masculine',
        synonyms: ['values', 'standards', 'beliefs'],
    },
    principled: {
        type: 'masculine',
        synonyms: ['ethical', 'moral', 'honorable'],
    },
    reckless : {
        type: 'masculine',
        synonyms: ['spontaneous', 'instinctive', 'thoughtless'],
    },
    recklessness: {
        type: 'masculine',
        synonyms: ['instinctiveness', 'spontaneity'],
    },
    'self-confidence': {
        type: 'masculine',
        synonyms: ['poise', 'assurance'],
    },
    'self-confident': {
        type: 'masculine',
        synonyms: ['poised', 'assured', 'self-assured'],
    },
    'self-reliance': {
        type: 'masculine',
        synonyms: ['resourceful', 'self-starter', 'enterprising'],
    },
    'self-reliant': {
        type: 'masculine',
        synonyms: ['resourceful', 'self-starter', 'enterprising'],
    },
    'self-sufficient': {
        type: 'masculine',
        synonyms: ['resourceful', 'enterprising'],
    },
    'self-sufficiency': {
        type: 'masculine',
        synonyms: ['resourcefulness', 'enterprising'],
    },
    selfconfidence: {
        type: 'masculine',
        synonyms: ['poise', 'assurance'],
    },
    selfconfident: {
        type: 'masculine',
        synonyms: ['poised', 'assured', 'self-assured'],
    },
    selfreliance: {
        type: 'masculine',
        synonyms: ['resourceful', 'self-starter', 'enterprising'],
    },
    selfreliant: {
        type: 'masculine',
        synonyms: ['resourceful', 'self-starter', 'enterprising'],
    },
    selfsufficient: {
        type: 'masculine',
        synonyms: [' resourceful', 'enterprising'],
    },
    selfsufficiency: {
        type: 'masculine',
        synonyms: ['resourcefulness', 'enterprising'],
    },
    stubborn : {
        type: 'masculine',
        synonyms: ['resolute', 'tenacious'],
    },
    stubbornly: {
        type: 'masculine',
        synonyms: ['resolutely', 'tenaciously'],
    },
    stubbornness: {
        type: 'masculine',
        synonyms: ['perseverance', 'resolve'],
    },
    superior : {
        type: 'masculine',
        synonyms: ['exceptional', 'outstanding', 'better'],
    },
    superiority: {
        type: 'masculine',
        synonyms: ['ascendency', 'preeminence'],
    },
    unreasonableness: {
        type: 'masculine',
        synonyms: ['unfairness', 'unbending', 'injustice'],
    },
    unreasonable: {
        type: 'masculine',
        synonyms: ['unbending', 'impractical', 'baseless'],
    },
}
